/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

// PRESETS

export const GET_FARM_RUN = 'GET_FARM_RUN';
export const GET_FARM_RUN_SUCCESS = 'GET_FARM_RUN_SUCCESS';

export const CREATE_FARM_RUN = 'CREATE_FARM_RUN';
export const CREATE_FARM_RUN_SUCCESS = 'CREATE_FARM_RUN_SUCCESS';

export const EDIT_FARM_RUN = 'EDIT_FARM_RUN';
export const EDIT_FARM_RUN_SUCCESS = 'EDIT_FARM_RUN_SUCCESS';

// ERROR

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const ERROR = 'FARM_ERROR';